import { createDiagnosisResultPage } from '../diagnosis-results/createDiagnosisResultPage';

export default createDiagnosisResultPage('PRLZ');
